export default __webpack_public_path__ + "static/media/About-Tower-viajes-2.25194044.jpg";